import * as React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { ILegacyRoute, LEGACY_SHIPMENTS, legacyRoutes } from './legacy-routes';

interface IProps {
    /** Where someone who still has the address of the old shipments page should go */
    shipmentsPage: () => string;
}

/**
 * Send the visitor to a page's address now, keeping what came after the old address and the query string
 */
const redirectToCurrentAddress = (to: string) => ({ match, location }: RouteComponentProps) => (
    <Redirect to={{
        pathname: to + location.pathname.slice(match.url.length),
        search: location.search,
        hash: location.hash
    }} />
);

/**
 * The routes for pages that are no longer at the address they used to be
 */
export const LegacyRedirects = (props: IProps) => (
    <>
        <Route
            key="legacy-shipments"
            exact={true}
            path={LEGACY_SHIPMENTS}
            render={() => <Redirect to={ props.shipmentsPage() } />}
        />

        {
            legacyRoutes.map((legacy: ILegacyRoute) => (
                <Route
                    key={ `legacy-${ legacy.from }` }
                    path={ legacy.from }
                    render={ redirectToCurrentAddress(legacy.to) }
                />
            ))
        }
    </>
);
